import { Link } from 'react-router-dom'

import { AcornsIcon } from '@acorns/icons'
import { Heading2 } from '@acorns/web-components'
import styled from 'styled-components'

export const AddMoreLinkStyle = styled(Link)`
  all: unset;
  align-items: center;
  cursor: pointer;
  display: flex;
  flex-direction: row;
`

export const AddMoreIcon = styled.div`
  align-items: center;
  background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='100' ry='100' stroke='%23CCCFCF' stroke-width='4' stroke-dasharray='9%25%2c 12%25' stroke-dashoffset='0' stroke-linecap='butt'/%3e%3c/svg%3e");
  border-radius: 100px;
  display: flex;
  height: 60px;
  justify-content: center;
  margin-right: 15px;
  width: 60px;
`

export const StyledPlusIcon = styled(AcornsIcon)`
  path {
    &[fill] {
      fill: ${(props) => props.theme.colors.stone};
    }
  }
`

export const AddMoreText = styled(Heading2)`
  color: ${(props) => props.theme.colors.stone};
`
